export default __webpack_public_path__ + "static/product2-38342f56a76375be3f04a2c2748b0c20.jpg";